import { render, staticRenderFns } from "./AnonymousMessage.vue?vue&type=template&id=1e1d9d54&scoped=true&"
import script from "./AnonymousMessage.vue?vue&type=script&lang=js&"
export * from "./AnonymousMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d9d54",
  null
  
)

export default component.exports